export default function capitalize() {
  return function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
}
